import React from "react";
import {
	DateField,
	DateTimeInput,
	Edit,
	ReferenceInput,
	SelectInput,
	SimpleForm,
	TextField,
	TextInput,
} from "react-admin";
import { Box, Card, CardContent, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import dateFormat from "dateformat";


const DonationEditAside = ({ record }) => (
	<>
		<Box m="0 0 1em 1em">
			<Card>
				<CardContent>
					<Typography variant="h6" gutterBottom>
						Historique
					</Typography>
					<Box display="flex" mb="1em">
						<Box mr="1em">
							<AccessTimeIcon fontSize="small" color="disabled" />
						</Box>
						<Box flexGrow={1}>
							<Typography>Créé le</Typography>
							<DateField record={record} source="created_date" />
						</Box>
					</Box>
					<Box display="flex" mb="1em">
						<Box mr="1em">
							<AccessTimeIcon fontSize="small" color="disabled" />
						</Box>
						<Box flexGrow={1}>
							<Typography>Dernière edition le</Typography>
							<DateField record={record} source="updated_date" />
						</Box>
					</Box>
				</CardContent>
			</Card>
		</Box>
	</>
);

const DonationEdit = (props) => (
	<Edit
		aside={<DonationEditAside />}
		{...props}
		transform={(data) => ({
			...data,
			donation_date: dateFormat(data.donation_date, "isoDateTime"),
		})}
		mutationMode="pessimistic"
	>
		<SimpleForm>
			{/*<TextField source="id"/>*/}
			<TextInput source="amount" label="Montant" />
			<TextInput source="firstname" label="Prénom" />
			<TextInput source="lastname" label="Nom" />
			<DateTimeInput source="donation_date" label="Date du don" />
			<ReferenceInput source="campaign_id" reference="campaign">
				<SelectInput label="Campagne" optionText="abstract_title" />
			</ReferenceInput>
			<TextInput source="affectation_code" label="Code affectation" />
			<TextInput source="origin_code" label="Code origine" />
		</SimpleForm>
	</Edit>
);

export default DonationEdit;
